import { render, staticRenderFns } from "./DashboardBilletTotalColumn.vue?vue&type=template&id=ec22eb58"
import script from "./DashboardBilletTotalColumn.vue?vue&type=script&lang=js"
export * from "./DashboardBilletTotalColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports